import { z } from "zod";
/** Visao do placar: admin ve o real, public ve o congelado. */
export const SCOREBOARD_VIEWS = ["admin", "public"];
export const scoreboardViewSchema = z.enum(SCOREBOARD_VIEWS);
export const CELL_STATES = ["NONE", "SOLVED", "WRONG", "PENDING"];
//# sourceMappingURL=scoreboard.js.map